module.exports = __webpack_public_path__ + "482b7813b003b064042f8de48ec697ab.pdf";